// src/index.ts
import { createClient } from "@supabase/supabase-js";
export * from "@supabase/supabase-js";

// src/api.ts
var Constants = {
  graphql_public: {
    Enums: {}
  },
  public: {
    Enums: {
      asset: ["crypto", "equities", "forex", "commodity"],
      direction: ["long", "short"],
      duration: ["intraday", "multiday"],
      notification_type: [
        "unread-mention",
        "unread-messages",
        "calendar-event",
        "new-phq"
      ],
      pattern_specification: [
        "extremely-high-slung",
        "high-slung",
        "broadly-symmetrical-high-side",
        "perfectly-symmetrical",
        "broadly-symmetrical-low-side",
        "low-slung",
        "extremely-low-slung"
      ],
      role: [
        "commander",
        "admin",
        "captain",
        "full_lieutenant",
        "second_lieutenant",
        "staff_sergant",
        "sergeant",
        "corporal",
        "lance_corporal",
        "rifleman",
        "recruit"
      ],
      setup_status: ["published", "archived"],
      stage: [
        "unspecified",
        "forming",
        "funneling",
        "triggered",
        "first_interim",
        "second_chance",
        "second_interim",
        "target",
        "overperformance",
        "failed",
        "stopped"
      ],
      user_status: ["applicant", "approved", "active", "cancelled"]
    }
  }
};

// src/derived.ts
var stageList = [
  "failed",
  "overperformance",
  "stopped",
  "target",
  "triggered",
  "forming",
  "funneling",
  "first_interim",
  "second_chance",
  "second_interim",
  "unspecified"
];
var directionList = [
  "long",
  "short"
];
var patternSpecificationList = [
  "broadly-symmetrical-high-side",
  "broadly-symmetrical-low-side",
  "extremely-high-slung",
  "extremely-low-slung",
  "high-slung",
  "low-slung",
  "perfectly-symmetrical"
];
var durationList = [
  "intraday",
  "multiday"
];
var assetList = [
  "commodity",
  "crypto",
  "equities",
  "forex"
];

// src/contract.ts
import { initContract } from "@ts-rest/core";
import { object, string } from "valibot";
var c = initContract();
var contract = c.router({
  getProfile: {
    method: "GET",
    path: "/profile/:userId",
    pathParams: object({
      userId: string()
    }),
    responses: {
      200: c.type(),
      404: c.type()
    },
    summary: "Get a user profile by ID"
  },
  getPaymentsLink: {
    method: "GET",
    path: "/payments/link",
    responses: {
      200: c.type(),
      401: c.type()
    },
    summary: "Get SSO link for payments portal"
  }
});

// src/index.ts
var supabase;
var cachedEnv = null;
function getEnv() {
  if (cachedEnv) return cachedEnv;
  let url;
  let key;
  if (typeof window !== "undefined") {
    url = import.meta.env.VITE_SUPABASE_URL;
    key = import.meta.env.VITE_SUPABASE_API_KEY;
  } else {
    url = process.env.VITE_SUPABASE_URL;
    key = process.env.SUPABASE_SERVICE_ROLE_KEY;
  }
  if (!url || !key) {
    throw new Error("Supabase URL or API key is not defined.");
  }
  cachedEnv = { url, key };
  return cachedEnv;
}
var api = () => {
  if (!supabase) {
    const { url, key } = getEnv();
    console.log(`initilaising supabase client with: 
${url}
${key}`);
    supabase = createClient(url, key);
  }
  return supabase;
};
export {
  Constants,
  api,
  assetList,
  contract,
  directionList,
  durationList,
  getEnv,
  patternSpecificationList,
  stageList
};
//# sourceMappingURL=index.mjs.map